import * as React from 'react';

import { PaginationWrapper } from './paginationWrapperComponents';
import { PaginationLink } from './paginationLinkComponents';
import { ReactComponent as PointerLeftIcon } from 'svg/pointer-left.svg';
import { ReactComponent as PointerRightIcon } from 'svg/pointer-right.svg';

const VISIBLE_PAGES = 7;
const VISIBLE_PAGES_AROUND = Math.floor(VISIBLE_PAGES / 2);

type TProps = {
  basePath: string;
  totalPages: number;
  currentPage: number;
};

export const Pagination = (props: TProps) => {
  const { currentPage, totalPages, basePath } = props;

  const visiblePages = React.useMemo(() => {
    let startPage = currentPage - VISIBLE_PAGES_AROUND;

    if (startPage < 1) {
      startPage = 1;
    }
    const pages = [startPage];

    while (pages.length < VISIBLE_PAGES) {
      if (pages[pages.length - 1] < totalPages) {
        pages.push(pages[pages.length - 1] + 1);
      } else if (pages[0] > 1) {
        pages.unshift(pages[0] - 1);
      } else {
        break;
      }
    }

    return pages;
  }, [currentPage, totalPages]);

  const hasBackLink = currentPage > VISIBLE_PAGES_AROUND + 1;

  const hasForwardLink = currentPage < totalPages - VISIBLE_PAGES_AROUND;

  return (
    <PaginationWrapper>
      {hasBackLink && (
        <PaginationLink
          to={`${basePath}/${currentPage - 1}`}
          text={<PointerLeftIcon />}
        />
      )}
      {visiblePages.map((num: number) => (
        <PaginationLink
          asNavLink
          key={num}
          text={`${num}`}
          to={`${basePath}/${num}`}
        />
      ))}
      {hasForwardLink && (
        <PaginationLink
          to={`${basePath}/${currentPage + 1}`}
          text={<PointerRightIcon />}
        />
      )}
    </PaginationWrapper>
  );
};
